// ============================================
// СЛАЙДЕР НОВОСТЕЙ
// ============================================
// Код слайдера новостей вынесен из script.js
// Включает: десктопный слайдер и мобильную карусель

// ---------- Слайдер новостей (block19) - только для 769px+ ----------
(function() {
  if (document.body.classList.contains('middle-high-page') || document.body.classList.contains('primary-school-page')) return;
  // Работаем только на 769px+ (на 768px используется бесконечная карусель)
  if (window.innerWidth <= 768) return;
  
  const newsSlides = document.getElementById('newsSlides');
  const newsPrevBtn = document.getElementById('newsPrev');
  const newsNextBtn = document.getElementById('newsNext');
  
  if (!newsSlides || !newsPrevBtn || !newsNextBtn) return;
  
  const newsCards = newsSlides.querySelectorAll('.news_card');
  let currentPage = 0;
  
  // Функция для определения количества карточек, которые полностью помещаются в блок по ширине
  function getVisibleCardsCount() {
    if (newsCards.length === 0) return 0;
    
    const containerRect = newsSlides.getBoundingClientRect();
    const containerWidth = containerRect.width;
    let visibleCount = 0;
    let totalWidth = 0;
    const gap = 15; // gap между карточками из CSS
    
    for (let i = 0; i < newsCards.length; i++) {
      const card = newsCards[i];
      const cardRect = card.getBoundingClientRect();
      const cardWidth = cardRect.width;
      
      // Учитываем gap только между карточками (не перед первой)
      const widthWithGap = i > 0 ? cardWidth + gap : cardWidth;
      
      if (totalWidth + widthWithGap <= containerWidth) {
        totalWidth += widthWithGap;
        visibleCount++;
      } else {
        break;
      }
    }
    
    return visibleCount;
  }
  
  // Функция для вычисления максимального количества нажатий направо
  function getMaxNextClicks() {
    const visibleCount = getVisibleCardsCount();
    return Math.max(0, newsCards.length - visibleCount);
  }
  
  let maxNextClicks = getMaxNextClicks(); // Максимальное количество нажатий направо
  
  // Функция для определения количества карточек для прокрутки
  function getCardsToScroll() {
    return 1;
  }
  
  // Функция для пересчета totalPages
  function getTotalPages() {
    const cardsToScroll = getCardsToScroll();
    return Math.ceil(newsCards.length / cardsToScroll);
  }
  
  function isLastCardFullyVisible() {
    if (newsCards.length === 0) return true;
    const lastCard = newsCards[newsCards.length - 1];
    const containerRect = newsSlides.getBoundingClientRect();
    const lastCardRect = lastCard.getBoundingClientRect();
    return lastCardRect.right <= containerRect.right;
  }
  
  function scrollToPage(page) {
    const cardsToScroll = getCardsToScroll();
    const totalPages = getTotalPages();
    
    if (page < 0) page = 0;
    
    // Если пытаемся перейти на страницу после последней, проверяем видимость последнего элемента
    if (page >= totalPages) {
      if (!isLastCardFullyVisible()) {
        // Прокручиваем до конца, чтобы показать последний элемент полностью
        const lastCard = newsCards[newsCards.length - 1];
        const containerRect = newsSlides.getBoundingClientRect();
        const lastCardRect = lastCard.getBoundingClientRect();
        const scrollLeft = newsSlides.scrollLeft + (lastCardRect.right - containerRect.right) + 20;
        
        newsSlides.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
        currentPage = totalPages - 1;
      } else {
        page = totalPages - 1;
        currentPage = page;
      }
    } else {
      currentPage = page;
      const index = page * cardsToScroll;
      const card = newsCards[index];
      
      if (card) {
        const containerRect = newsSlides.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const gap = 15; // gap между карточками
        const scrollLeft = newsSlides.scrollLeft + (cardRect.left - containerRect.left) - gap;
        
        newsSlides.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }
    
    // Обновляем кнопки после завершения прокрутки
    setTimeout(updateButtons, 300);
  }
  
  newsPrevBtn.addEventListener('click', () => {
    scrollToPage(currentPage - 1);
  });
  
  newsNextBtn.addEventListener('click', () => {
    // Проверяем, не превысили ли максимальное количество нажатий направо
    if (currentPage < maxNextClicks) {
      scrollToPage(currentPage + 1);
    }
  });
  
  function updateButtons() {
    const totalPages = getTotalPages();
    newsPrevBtn.style.opacity = currentPage > 0 ? '1' : '0.5';
    newsPrevBtn.style.cursor = currentPage > 0 ? 'pointer' : 'not-allowed';
    
    // Кнопка направо активна только если не превышено максимальное количество нажатий
    const canClickNext = currentPage < maxNextClicks;
    newsNextBtn.style.opacity = canClickNext ? '1' : '0.5';
    newsNextBtn.style.cursor = canClickNext ? 'pointer' : 'not-allowed';
  }
  
  // Пересчитываем при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Работаем только на 769px+
      if (window.innerWidth <= 768) return;
      // Пересчитываем maxNextClicks при изменении размера
      maxNextClicks = getMaxNextClicks();
      currentPage = Math.min(currentPage, getTotalPages() - 1);
      updateButtons();
    }, 100);
  });
  
  // Добавляем обработчик клика на карточки новостей
  newsCards.forEach(card => {
    card.style.pointerEvents = 'auto';
    card.style.cursor = 'pointer';
    
    card.addEventListener('click', (e) => {
      
      // Пример: можно получить заголовок новости
      const title = card.querySelector('.news_title');
      if (title) {
      }
    });
  });
  
  updateButtons();
})();

// Бесконечная карусель для block19_slider_wrapper при 768px (как reviewsSlider)
// ============================================
(function() {
  if (document.body.classList.contains('middle-high-page') || document.body.classList.contains('primary-school-page')) return;
  let newsSlides = null;
  let newsSliderWrapper = null;
  let currentNewsIndex = 0;
  let isTransitioning = false;
  let isAnimating = false;
  const newsGap = 15;
  const newsWidth = 280; // При 768px

  function getNewsWidth() {
    return newsWidth;
  }

  function getNewsStep() {
    return getNewsWidth() + newsGap;
  }

  function getTransitionDuration() {
    return '0.4s';
  }

  function getTransitionDurationMs() {
    return 400;
  }

  function getRealNews() {
    if (!newsSlides) return [];
    return Array.from(newsSlides.querySelectorAll('.news_card:not(.news-card-clone)'));
  }

  function cloneNews() {
    if (!newsSlides || window.innerWidth > 768) {
      if (newsSlides) {
        const oldClones = newsSlides.querySelectorAll('.news-card-clone');
        oldClones.forEach(clone => clone.remove());
      }
      return;
    }

    const realNews = getRealNews();
    if (realNews.length === 0) return;

    const oldClones = newsSlides.querySelectorAll('.news-card-clone');
    oldClones.forEach(clone => clone.remove());

    const fragmentBefore = document.createDocumentFragment();
    realNews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('news-card-clone');
      fragmentBefore.appendChild(clone);
    });
    newsSlides.insertBefore(fragmentBefore, realNews[0]);

    realNews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('news-card-clone');
      newsSlides.appendChild(clone);
    });
  }

  function updateNewsSlider() {
    if (!newsSlides || window.innerWidth > 768) return;

    const realNews = getRealNews();
    if (realNews.length === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentNewsIndex < 0) {
      currentNewsIndex = 0;
    }
    if (currentNewsIndex >= realNews.length) {
      currentNewsIndex = realNews.length - 1;
    }

    const centerX = window.innerWidth / 2;
    const containerRect = newsSliderWrapper ? newsSliderWrapper.getBoundingClientRect() : newsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;

    const currentNewsWidth = getNewsWidth();
    const currentNewsStep = getNewsStep();
    const newsCenterX = currentNewsWidth / 2;
    const realNewsIndexInDOM = realNews.length + currentNewsIndex;
    const activeNewsLeftPosition = realNewsIndexInDOM * currentNewsStep;
    const activeNewsCenterPosition = activeNewsLeftPosition + newsCenterX;

    const translateX = centerX - containerLeft - activeNewsCenterPosition;

    // Всегда устанавливаем transition для обычных переходов
    if (!isTransitioning) {
      newsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    newsSlides.style.transform = `translateX(${translateX}px)`;
  }

  function goToNextNews() {
    if (isAnimating || window.innerWidth > 768) return;

    const realNews = getRealNews();
    const realNewsCount = realNews.length;

    if (currentNewsIndex < realNewsCount - 1) {
      isAnimating = true;
      currentNewsIndex++;
      updateNewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const firstCloneIndex = realNewsCount * 2;
      const currentNewsStep = getNewsStep();
      const containerRect = newsSliderWrapper ? newsSliderWrapper.getBoundingClientRect() : newsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentNewsWidth = getNewsWidth();
      const newsCenterX = currentNewsWidth / 2;
      const activeNewsLeftPosition = firstCloneIndex * currentNewsStep;
      const activeNewsCenterPosition = activeNewsLeftPosition + newsCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeNewsCenterPosition;

      newsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      newsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        newsSlides.style.transition = 'none';
        currentNewsIndex = 0;
        const realNewsCount = realNews.length;
        const currentNewsStep = getNewsStep();
        const containerRect = newsSliderWrapper ? newsSliderWrapper.getBoundingClientRect() : newsSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentNewsWidth = getNewsWidth();
        const newsCenterX = currentNewsWidth / 2;
        const realNewsIndexInDOM = realNewsCount + currentNewsIndex;
        const activeNewsLeftPosition = realNewsIndexInDOM * currentNewsStep;
        const activeNewsCenterPosition = activeNewsLeftPosition + newsCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeNewsCenterPosition;
        newsSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            newsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function goToPrevNews() {
    if (isAnimating || window.innerWidth > 768) return;

    const realNews = getRealNews();
    const realNewsCount = realNews.length;

    if (currentNewsIndex > 0) {
      isAnimating = true;
      currentNewsIndex--;
      updateNewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const lastCloneIndex = realNewsCount - 1;
      const currentNewsStep = getNewsStep();
      const containerRect = newsSliderWrapper ? newsSliderWrapper.getBoundingClientRect() : newsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentNewsWidth = getNewsWidth();
      const newsCenterX = currentNewsWidth / 2;
      const activeNewsLeftPosition = lastCloneIndex * currentNewsStep;
      const activeNewsCenterPosition = activeNewsLeftPosition + newsCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeNewsCenterPosition;

      newsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      newsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        newsSlides.style.transition = 'none';
        currentNewsIndex = realNewsCount - 1;
        const currentNewsStep = getNewsStep();
        const containerRect = newsSliderWrapper ? newsSliderWrapper.getBoundingClientRect() : newsSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentNewsWidth = getNewsWidth();
        const newsCenterX = currentNewsWidth / 2;
        const realNewsIndexInDOM = realNewsCount + currentNewsIndex;
        const activeNewsLeftPosition = realNewsIndexInDOM * currentNewsStep;
        const activeNewsCenterPosition = activeNewsLeftPosition + newsCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeNewsCenterPosition;
        newsSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            newsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function getInitialTranslate() {
    const realNews = getRealNews();
    const containerRect = newsSliderWrapper ? newsSliderWrapper.getBoundingClientRect() : newsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;
    const centerX = window.innerWidth / 2;
    const currentNewsWidth = getNewsWidth();
    const currentNewsStep = getNewsStep();
    const newsCenterX = currentNewsWidth / 2;
    const realNewsIndexInDOM = realNews.length + currentNewsIndex;
    const activeNewsLeftPosition = realNewsIndexInDOM * currentNewsStep;
    const activeNewsCenterPosition = activeNewsLeftPosition + newsCenterX;

    if (window.innerWidth <= 768 && currentNewsIndex === 0) {
      const viewportCenter = window.innerWidth / 2;
      return viewportCenter - containerLeft - activeNewsCenterPosition;
    } else {
      return centerX - containerLeft - activeNewsCenterPosition;
    }
  }

  function init() {
    if (window.innerWidth > 768) return;

    newsSlides = document.getElementById('newsSlides');
    if (!newsSlides) return;

    newsSliderWrapper = newsSlides.closest('.block19_slider_wrapper') || newsSlides.parentElement;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    cloneNews();
    currentNewsIndex = 0;
    
    // Инициализация позиции
    const initialNews = newsSlides.querySelectorAll('.news_card');
    if (initialNews.length > 0) {
      updateNewsSlider();
    }

    newsSlides.addEventListener('mousedown', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      isDragging = true;
      startX = e.clientX;
      initialTranslate = getInitialTranslate();
      newsSlides.classList.add('dragging');
      e.preventDefault();
    });

    newsSlides.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      newsSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
    });

    newsSlides.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      newsSlides.classList.remove('dragging');

      const threshold = getNewsStep() / 6;
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevNews();
        } else {
          goToNextNews();
        }
      } else {
        updateNewsSlider();
      }
      currentX = 0;
    });

    newsSlides.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        newsSlides.classList.remove('dragging');
        updateNewsSlider();
        currentX = 0;
      }
    });

    newsSlides.addEventListener('touchstart', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchInitialTranslate = getInitialTranslate();
      newsSlides.classList.add('dragging');
    });

    newsSlides.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;

      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }

      newsSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
    });

    newsSlides.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      newsSlides.classList.remove('dragging');

      const threshold = getNewsStep() / 6;
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevNews();
        } else {
          goToNextNews();
        }
      } else {
        updateNewsSlider();
      }
      touchCurrentX = 0;
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth <= 768) {
          cloneNews();
          updateNewsSlider();
        } else {
          cloneNews();
        }
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }

  window.addEventListener('load', () => {
    if (window.innerWidth <= 768) {
      currentNewsIndex = 0;
      updateNewsSlider();
    }
  });
})();

